import React from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { mainURL } from "../../utils/common";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";

const Education_part = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t("About Us")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t(
                          "VARIOUS SCHEMES AND PROGRAMMES FOR THE BENEFIT OF THE LEARNERS OF KMCP SCHOOLS AND SSKS"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t("FAQ")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        target="_blank"
                        to="/Education_Dept"
                      >
                        {t("Contact Details")}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title">
                    <h3> {t("KMC Education")} </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Education_part;
